import React, {useEffect, useState} from 'react';
import {defaultStatusColumns, SEColumns, shouldDisable} from './status.utils';


import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';
import StatusTable from './statusTable/index.js';
import { Col, Checkbox, Row, Input } from 'antd';
import CommentBox from './DailogBox';
import {isAdministrator} from "../../utils/UserInfo";

function SEView(props) {
  const {
    project,
    handleProjectDetailUpdate,
    comments,
    isReadOnly,
    SEDropDownOptions,
    phaseDetails,
    phaseId,
    isProjectOnHold,
  } = props;

  const [selectedDropdownOptions, setSelectedDropdownOptions] = useState([]);

  useEffect( () => {
    // if (phaseDetails?.seAssetsStatus !== null) {
    //   let options = [];
    //   let index = SEDropDownOptions.indexOf(phaseDetails?.seAssetsStatus);
    //   // We are checking here if we have status 'IPS Locations Created then we will show 2 options
    //   if(index < 5) options.push(SEDropDownOptions[index+1]);
    //   if(index <= 5 && index > 0) options.push(SEDropDownOptions[index-1]);
    //   setSelectedDropdownOptions(options);
    // }
    // else {
      setSelectedDropdownOptions([...SEDropDownOptions]);
    // }
  }, [phaseDetails?.seAssetsStatus, SEDropDownOptions]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [SEAssetsExpected, setSEAssetsExpected] = useState(
    phaseDetails
    ? phaseDetails.expectedSEAssetsCnt
    : 0
  )

  const handleCommentDialogueSubmit = (comment) => {
    // we are combining Flag + comment so we don't have to make  two calls

    handleProjectDetailUpdate(`N-${comment}`, 'SE_ASSETS_FLAG', 'string',phaseId);

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const seAssetSheetHandler = (e) => {
    let value = e.target.checked ? 'N' : 'Y';

    if (e.target.checked) {
      setIsModalOpen(true);
    } else {
      handleProjectDetailUpdate(value, 'SE_ASSETS_FLAG', 'string',phaseId);
    }
  };

  let handleNoOfAssetsChange = () => {

    
    handleProjectDetailUpdate(SEAssetsExpected, 'EXPECTED_SE_ASSETS_CNT', 'number',phaseId);
  };
  const setNoSEAssetsExpected = (e) => {
    const { value } = e.target;
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
      setSEAssetsExpected(Number(value));
    }
  }
  return (
    <>
      <div>
        <section className='padding-container'>
          <Row justify='end' align='middle' gutter={25}>
            <Col className='d-flex flex-column'>
              {' '}
              <div className='d-flex flex-row'>
              <span className='key-title pr-1'>CCA SLA:</span>
              {phaseDetails?.seAssetsSLA && ` ${phaseDetails?.seAssetsSLA}`}
              </div>
              <div className='d-flex flex-row'>
                <span className='key-title pr-1'>Engineering SLA:</span>
                {phaseDetails?.seAssetsEngSLA && ` ${phaseDetails?.seAssetsEngSLA}`}
              </div>
              <div className='d-flex flex-row'>
                <span className='key-title pr-1'>Total SLA:</span>
                {` ${(phaseDetails.seAssetsSLA===null?0:phaseDetails.seAssetsSLA) + (phaseDetails.seAssetsEngSLA===null?0:phaseDetails.seAssetsEngSLA)}`}
              </div>
            </Col>
            <Col>
              <IpsDTCommentsIcon
                project={project}
                comments={comments}
                commentGroup={'SE'}
                phase={phaseId}

              />
            </Col>
          </Row>
          <Row className='se-pce-space'>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  SE Asset Sheets
                </Col>
                <Col>
                  <Checkbox
                    onChange={seAssetSheetHandler}
                    defaultChecked={false}
                    checked={phaseDetails?.seAssetsFlag === 'N'}
                    style={{
                      display: 'flex',
                      border: 'none',
                      padding: 0,
                      margin: 0,
                    }}
                    disabled={isProjectOnHold||isReadOnly}
                  />
                </Col>
                <Col
                  style={{ marginLeft: '5px' }}
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  N/A
                </Col>
                <CommentBox
                  show={isModalOpen}
                  handleCommentDialogueSubmit={handleCommentDialogueSubmit}
                  name={'SE Assets Sheet'}
                  handleCancel={handleCancel}
                />
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  {''}
                </Col>
                {phaseDetails && phaseDetails.seChangedDate && (
                  <Col>{`${phaseDetails.seChangedUser}  ${phaseDetails.seChangedDate}`}</Col>
                )}
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  {''}
                </Col>
                {phaseDetails && phaseDetails.seChangedDate && phaseDetails.seAssetsComments && (
                  <Col>{`${phaseDetails.seAssetsComments}`}</Col>
                )}
              </Row>
            </Col>

            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  SE Engineer:
                </Col>
                {project && project.seNames && (
                  <Col>{`${project.seNames}`}</Col>
                )}
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  SE Assets Expected:
                </Col>
                <Col className='asset-input'>
                 
                  <Input
                    
                    // min={0}
                    size='small'
                    value={
                      SEAssetsExpected
                    }
                    
                    // onChange={handleNoOfAssetsChange}
                    onBlur={handleNoOfAssetsChange}
                    onChange={setNoSEAssetsExpected}
                    disabled={
                      isReadOnly ||isProjectOnHold|| phaseDetails?.seAssetsFlag === 'N'
                    }
                  />
                </Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  {' '}
                  SE Assets Received :
                </Col>
                <Col>{project.noOfSEAssets}</Col>
              </Row>
            </Col>
          </Row>

          <StatusTable
            dataSource={phaseDetails?.seAssetsHistory}
            dropOptions={selectedDropdownOptions}
            disabledButtons={
              isReadOnly ||isProjectOnHold||
              phaseDetails?.seAssetsFlag === 'N' ||
              shouldDisable(
                phaseDetails?.seAssetsStatus ===
                  selectedDropdownOptions[selectedDropdownOptions?.length - 1]
              )
            }
            fieldName = {'SE_ASSETS_STATUS'}
            currentStatus = {phaseDetails.seAssetsStatus}
            phaseId = {phaseId}
            disableDelete = {project.trackerStatus === 'DT_C' ? true : false}
            handleProjectDetailUpdate = {handleProjectDetailUpdate}
          />
        </section>
      </div>
    </>
  );
}
export default SEView;